import graphql from "babel-plugin-relay/macro";
import create_mocked_environment from "../graphql/create_environment";
import { commitMutation } from "react-relay";

let fake_asset = {
  createdAt: new Date(),
  fileType: "jpg",
  fileUrl: "www.bla.com",
  id: "123",
  name: "MyImage",
  thumbnailUrl: "www.bla.com"
};

const fake_environment = {
  Asset: () => fake_asset,
  Mutation: (root, params, index) => ({
    asset: fake_asset,
    clientMutationId: params.clientMutationId
  })
};

export default (input, environment, callback) => {
  const mutation = graphql`
    mutation uploadAssetMutation($input: uploadAssetInput!) {
      uploadAsset(input: $input) {
        asset {
          id
          name
          fileUrl
          fileSize
          fileType
          thumbnailUrl
          createdAt
        }
      }
    }
  `;

  const variables = {
    input: input
  };

  commitMutation(environment || create_mocked_environment(fake_environment), {
    mutation,
    variables,
    onCompleted: callback,
    onError: err => console.error("Api Error", err)
  });
};
